import { FlashMessagesNotificationTypes } from './types';

export const getFlashMessageNotifications = () => ({
  types: [
    FlashMessagesNotificationTypes.SHOW_REQUEST,
    FlashMessagesNotificationTypes.SHOW_SUCCESS,
    FlashMessagesNotificationTypes.SHOW_FAILURE,
  ],
  promise: (client: any) => client.get('/notification/flash_messages'),
});
